export const about_ministry=`/v2/guest/about-ministry`